/**
 * Tibbs's last-card tip (game/lastCardTip.ts): the coach's bubble, docked over
 * the me bar so it never covers a pile or a card you might tap. It does not
 * dim the table or pause anything; the × closes it for the rest of the game.
 */
import { LAST_CARD_TIP } from '../../game/lastCardTip';
import { Tibbs } from '../Art';
import { IconClose } from '../Icons';

export function LastCardTip({ onClose }: { onClose: () => void }) {
  return (
    <div className="tip-bubble" role="note" aria-label="Tip">
      <Tibbs pose="point" size={48} className="tip-tibbs" />
      <p className="tip-text" aria-live="polite">
        <span>{LAST_CARD_TIP[0]}</span> <span>{LAST_CARD_TIP[1]}</span>
      </p>
      <button type="button" className="icon-btn tip-x" aria-label="Hide this tip" onClick={onClose}>
        <IconClose size={16} />
      </button>
    </div>
  );
}
